module.exports = __webpack_public_path__ + "static/media/monitor.98a4eeb7.svg";